import ApiCore from './ApiCore';

const makeSearchParams = obj => Object.entries(obj).map(([k, v]) => `${k}=${v}`).join('&')

const getAllPages = async (search, max_page_size = 180) => {
  let results = []
  let page_size = max_page_size

  while(
    await search(results.length, page_size)
      .then(response => {
        page_size = Math.min(max_page_size, Math.round(page_size * 1.35))
        results = results.concat(response)
        return response.length > 0
      })
      .catch(err => {
        if (page_size > 1) {
          page_size = Math.round(page_size / 2)
          return true
        }
        throw err
      })
  ){}

  return results
}

class SearchService extends ApiCore {

  async search(filter) {

    const search = (offset, limit) => {
      const params = makeSearchParams({
        q: '*',
        filter_by: encodeURIComponent(filter),
        group_by: 'siglaCampione',
        sort_by: 'siglaMacrolotto:asc,siglaSondaggio:asc,siglaCampione:asc',
        offset: offset,
        limit: limit,
      })

      return this.instance.get('collections/cesidata/documents/search?' + params)
      .then(response => response.data.grouped_hits ?? [])
    }

    return getAllPages(search)
  }

  searchRdp(query = "*", filter) {

    const search = (offset, limit) => {
      const searchParameters = makeSearchParams({
        q: query,
        query_by: 'codice_cesi,siglaCampione',
        filter_by: encodeURIComponent(filter),
        sort_by: 'siglaMacrolotto:asc,siglaSondaggio:asc,siglaCampione:asc',
        offset,
        limit,
      })
  
      return this.instance.get('collections/cesidata/documents/search?' + searchParameters) // {data: {hits: [...]}}
      .then(response => response.data.hits ?? [])
    }

    return getAllPages(search, 1300)

  }

}

export default new SearchService()


// class CachedSearchService {

//   constructor() {
//     this.searchService = new SearchService()
//     this.ready = this.searchService.search('obj_type:VALUE').then((result) => this.searchValues = result)
//   }

//   async search(filter) {
//     const cache = await this.searchValues

//   }

// }

// export default new CachedSearchService();
